import { ADMIN_PATH, DOSSIERS_PATH, OFFERINGS_PATH } from './paths.constants';

export const MAIN_MENU_SETTINGS = [
  {
    label: 'Mijn dossiers',
    path: DOSSIERS_PATH
  },
  {
    label: 'Beheer',
    path: ADMIN_PATH
  },
  {
    label: 'Doe je aanvraag',
    path: OFFERINGS_PATH
  }
];
